import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import {
	RETIREMENT_AGE,
	RETIREMENT_EXAMPLE,
} from "web_myplann/Inspiration/Retirement/constants";
import { getRetirementBridgeYears } from "web_myplann/Inspiration/Retirement/Utils/getRetirementBridgeYears";
import { getRetirementGap } from "web_myplann/Inspiration/Retirement/Utils/getRetirementGap";
import { getRetirementTargetCapital } from "web_myplann/Inspiration/Retirement/Utils/getRetirementTargetCapital";

export const getRetirementExample = () => {
	const remaining =
		RETIREMENT_EXAMPLE.expenses -
		RETIREMENT_EXAMPLE.mortgage -
		RETIREMENT_EXAMPLE.savings;
	const gap = getRetirementGap(remaining, RETIREMENT_EXAMPLE.statePension);

	return {
		...RETIREMENT_EXAMPLE,
		remaining,
		gap,
		capital: getRetirementTargetCapital({
			desiredIncome: remaining,
			gap,
			bridgeYears: getRetirementBridgeYears(RETIREMENT_AGE),
			mode: RentDrawdownMode.ToZero,
		}),
	};
};
